module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABD0lEQVRIS93V/U3DQAwF8PcmoBsQJqAbUDZgg7YjsFG7QTco3QA2yAhsYPSkixRFUc6Ojwrh/xKd8pM/4iPuHLyzh78HmtkGQEfys0U1qhmamaBnACeSxyzqAXsAjwVKox5wC+ADwEMLtAoKMbMOwKWUVq9OAN5JfkdL7AILquFRpuqnQr19jaJusBUaAlugYXCEqqcv0fKuAodBMTMNz748a4DU08UFkQJLtmO0J/m0NLmtwRvJ3a+Bk5J+AdjVfpNVGZaFfgWgLaRwYToYBjNYGMxiIbAF5gZnsBuAt9qAzE1rtYcz2JnkIXpLDOc9oG6IYYWlMFdJzWwA05gX1D24JSk4HdWSpoXJB/4/+AOo2ngdOKniUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.png
// module id = qNF3
// module chunks = 1